export const FEATURE_FLAGS = {
  SUPER_API: 'pwf-7532-super-api',
  LEGAL_NAME: 'pwf-7477-legal-name',
};

export function shouldEnableLegalName() {
  return true;
}
